export default function Checkbox({ checked, onChange, className = '', ...props }) {
  return (
    <input
      type="checkbox"
      checked={checked ?? false}
      onChange={onChange}
      className={`h-4 w-4 cursor-pointer rounded border-line-strong accent-brand-600 ${className}`}
      {...props}
    />
  );
}
